export default "__VITE_ASSET__Dn0BO0$F__"